export function isWarming(data) {
  return Boolean(data) && data.status === "warming"
}

export function progressText(data) {
  if (!data || data.total == null) return ""
  return `${data.done} / ${data.total}`
}

export function warmingLabel(data) {
  if (data && data.fetching) return "Fetching faces"
  return "Warming the mosaic"
}

export function shouldKeepPolling(data) {
  return isWarming(data)
}

export function overlayHidden(data) {
  return !isWarming(data)
}
